import * as storage from '../persistance/storage';

export function parseJSON(response) {
	let status = response.status;
	return response.json().then((data) => {
		return {
			status: status,
			data: data
		};
	});
}

export function isOk(status) {
  if(status >= 200 && status < 300) {
    return true;
  } else {
    return false;
  }
}

export function authReq(headers) {
	let autk = storage.get('token');
	return Object.assign({}, headers, {'AUTK': autk});
}